import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
});

export const priceRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
});

export const priceText = css({
  fontSize: 'xl',
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const priceSuffix = css({
  fontSize: 'xl',
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const costsFeesRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  marginTop: 'xs',
});

export const costsFeesSeparator = css({
  color: '#e0e0e0',
  fontSize: 'sm',
});

export const costsFeesLink = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '2px',
  fontSize: 'sm',
  fontWeight: 'bold',
  color: 'hpxGrey600',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',

  _hover: {
    textDecoration: 'underline',
  },

  md: {
    fontSize: 'md',
  },
});

export const detailsRow = css({
  fontSize: 'md',
  color: 'hpxGrey600',
  marginTop: 'xs',
});

export const buildingName = css({
  fontWeight: 'bold',
  fontSize: 'md',
  color: 'hpxGrey600',
  marginTop: '2x',
});

export const addressText = css({
  fontSize: 'md',
  color: 'hpxGrey600',
});

export const addressTriggerRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  marginTop: '2x',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 0,
  textAlign: 'left',
});

export const websiteContainer = css({
  marginTop: '1x',
});

export const websiteLink = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'md',
  color: 'hpxTeal500',
  textDecoration: 'none',
  fontWeight: 'bold',

  _hover: {
    textDecoration: 'underline',
    color: 'hpxTeal600',
  },
});

export const externalIcon = css({
  width: '14px',
  height: '14px',
  marginLeft: 'xs',
});
